
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as _ref_QGpzLWpvZGEvY29yZQ_ from '@js-joda/core';
import * as _ref_QHRlbnNvcmZsb3cvdGZqcw_ from '@tensorflow/tfjs';
import { instantiate } from './composeApp.uninstantiated.mjs';


const exports = (await instantiate({
    './skiko.mjs': Li9za2lrby5tanM,
    '@js-joda/core': _ref_QGpzLWpvZGEvY29yZQ_,
    '@tensorflow/tfjs': _ref_QHRlbnNvcmZsb3cvdGZqcw_
})).exports;

export const {
main,
memory,
_initialize
} = exports


